<template>
    <div class="container">
        <router-view :key="$route.path"/>
    </div>
</template>

<script>
    export default {
        name: "Admin"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/admin/Index.vue